"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Twitter;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Twitter(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Twitter"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M79.791,34.724c.047.666.047,1.333.047,2,0,20.32-15.466,43.734-43.734,43.734a43.436,43.436,0,0,1-23.6-6.9,31.945,31.945,0,0,0,3.712.19A30.788,30.788,0,0,0,35.3,67.18,15.4,15.4,0,0,1,20.923,56.52a19.48,19.48,0,0,0,2.9.238,16.257,16.257,0,0,0,4.045-.524A15.373,15.373,0,0,1,15.545,41.149v-.191a15.484,15.484,0,0,0,6.948,1.951,15.4,15.4,0,0,1-4.759-20.558,43.694,43.694,0,0,0,31.7,16.085,17.347,17.347,0,0,1-.381-3.522A15.386,15.386,0,0,1,75.65,24.4a30.256,30.256,0,0,0,9.756-3.712,15.323,15.323,0,0,1-6.758,8.471A30.832,30.832,0,0,0,87.5,26.777a33.057,33.057,0,0,1-7.709,7.947Z"
  })));
}